<template>
    <alert-modal
        @close="close"
        @cancel="close"
        @overlayClick="close"
        class="cz2__special-box-modal"
    >
        <div>
            <div
                :style="{ backgroundImage: `url(${image})` }"
                class="cz2__special-box-image"
            />

            <h1
                v-html="titleText"
                class="cz2__special-box-title"
            />

            <p
                v-html="copyText"
                class="cz2__special-box-copy"
            />

            <btn
                primary
                @click="close"
            >
                <span v-html="ctaText" />
            </btn>
        </div>
    </alert-modal>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__special-box-modal {
            font-family: "Proxima Nova";

            .cz2__modal-popup__body {
                max-width: 432px;
                overflow: hidden;
            }

            .cz2__special-box-image {
                margin: 0 auto;
                width: 100%;
                aspect-ratio: 5/4;
                background-position: center;
                background-size: contain;
                background-repeat: no-repeat;
            }

            .cz2__special-box-title {
                margin-top: 24px;
                margin-bottom: 8px;
                @include font(feature);
                font-size: 32px;
                font-style: italic;
            }

            .cz2__btn {
                margin-top: 24px;
                margin-bottom: 8px;
                width: 100%;
                height: 48px;

                &:hover,
                &:focus {
                    font-size: 18px;
                    &::before {
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            @include respond-above(lg) {
                .cz2__special-box-copy {
                    font-size: 20px;
                }
            }
        }
    }
</style>

<script>
    import Btn from './ui/Btn.vue';
    import AlertModal from './ui/AlertModal.vue';

    import placeholder from '../assets/images/special-box-image.webp';
    import twoPackPlaceholder from '../assets/images/special-box-2-pack-placeholder.webp';

    import { formatPrice } from '../helpers/formatPrice';

    export default {
        components: {
            Btn,
            AlertModal,
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            price() {
                const component = this.viewController.findPlacement('POPFifaBundle')?.components?.find((x) => !x.placeholder);

                if (component) {
                    const priceValue = this.viewController.getPrice(component);

                    return priceValue;
                }

                return 0;
            },

            priceFormatted() {
                return formatPrice(this.$store.state, this.price, 'compact');
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            titleText() {
                const copy = this.isTwoPack ? this.$t('SPECIAL_BOX_2_PACK_TITLE') : this.$t('SPECIAL_BOX_TITLE');

                return copy.replace('{0}', this.priceFormatted);
            },

            copyText() {
                const copy = this.isTwoPack ? this.$t('SPECIAL_BOX_2_PACK_COPY') : this.$t('SPECIAL_BOX_COPY');

                return copy.replace('{0}', this.priceFormatted);
            },

            ctaText() {
                return this.isTwoPack ? this.$t('SPECIAL_BOX_2_PACK_CTA') : this.$t('SPECIAL_BOX_CTA');
            },

            image() {
                return this.isTwoPack ? twoPackPlaceholder : placeholder;
            },
        },

        methods: {
            close() {
                this.$store.dispatch('showSpecialBoxModal', false);
            },
        },
    };
</script>
